import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import Video from "components/General/Video/Video";
class ProjectContent extends React.Component {
  render() {
    return (
      <div className="insideContent share-story">
        <h3 className="textHeader">STEP 2 : SHARE YOUR STORY</h3>
        <TextTheme
          message="Create a personal video that tells your friends and family about your new project. Be sure to:"
          className="text_small text_semi_bold text_black"
        />

        <ul>
          <li>
            <TextTheme
              message="Explain why you chose this project."
              className="text_small text_black"
            />
          </li>
          <li>
            <TextTheme
              message="Explain why people should support the project mission."
              className="text_small text_black"
            />
          </li>
          <li>
            <TextTheme
              message="Ask your friends and family to join your project."
              className="text_small text_black"
            />
          </li>
          <li>
            <TextTheme
              message="Upload a video or photo"
              className="text_small text_black"
            />
          </li>
        </ul>
        <Video
          src={this.props.video}
          id="file"
          style={{ display: "none" }}
          type="file"
          name="video"
          accept="video/*"
          onChange={this.props.videoHandler.bind(this)}
          fileType={this.props.fileType}
          count={this.props.count}
          fileData = {this.props.fileData}
          displayCustomPopup={this.props.displayCustomPopup}
          displayImagePopup={this.props.displayImagePopup}
          displayCreationSuite = {this.props.displayCreationSuite}
          closePopUp = {this.props.closePopUp}
          openPopUp = {this.props.openPopUp}
          imagePopup = {this.props.imagePopup}
          popupControl={this.props.popupControl}
          uploadApi={this.props.uploadApi}
          fileUpload = {this.props.fileUpload}
          openCreationSuite = {this.props.openCreationSuite}
          closeCreationSuite = {this.props.closeCreationSuite}
          handleCreationSuiteUpload = {this.props.handleCreationSuiteUpload}
        />
      </div>
    );
  }
}

export default ProjectContent;
